var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownWhite = function SvgChevronDownWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "chevron-down-white_svg__a",
    width: 13,
    height: 13,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h13v13H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chevron-down-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.5 8.342-3.25-3.25.758-.759L6.5 6.825l2.492-2.492.758.759z"
  }))));
};
export { SvgChevronDownWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDEzIDEzIiBmaWxsPSJub25lIj4NCiAgPG1hc2sgaWQ9Im1hc2swXzFfMTczOSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjEzIiBoZWlnaHQ9IjEzIj4NCiAgICA8cmVjdCB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIGZpbGw9IiNEOUQ5RDkiLz4NCiAgPC9tYXNrPg0KICA8ZyBtYXNrPSJ1cmwoI21hc2swXzFfMTczOSkiPg0KICAgIDxwYXRoIGQ9Ik02LjUgOC4zNDE2N0wzLjI1IDUuMDkxNjdMNC4wMDgzMyA0LjMzMzMzTDYuNSA2LjgyNUw4Ljk5MTY3IDQuMzMzMzNMOS43NSA1LjA5MTY3TDYuNSA4LjM0MTY3WiIgZmlsbD0id2hpdGUiLz4NCiAgPC9nPg0KPC9zdmc+";